<div class="col-sm-12 coldx" >
	<h4>{{title}}</h4>
	<ng-template [ngIf]="petitumRevisioneForm">
	<form [formGroup]="petitumRevisioneForm" (ngSubmit)="save();">
		<div class="row">
			<div datePickerInput class="col-sm-4"
				[labelInput]="'Data inizio aggiornamento'"
				formControlName="dataRevisioneDa"
				[(ngModel)]="request.dataRevisioneDa"></div>
			<!-- <div textInput class="col-sm-4" [labelInput]="'Costi di gestione'"
				formControlName="costiGestione" [(ngModel)]="request.costiGestione"></div> -->
			<div textInput class="col-sm-4" [labelInput]="'Compensi'"
				formControlName="compensi" [(ngModel)]="request.compensi"></div>
			<div textInput class="col-sm-4" [labelInput]="'Spese'"
				formControlName="spese" [(ngModel)]="request.spese"></div>
			<div textInput class="col-sm-4" [labelInput]="'Altro'"
				formControlName="altro" [(ngModel)]="request.altro"></div>
			<div textInput class="col-sm-4" [labelInput]="'Motivo aggiornamento'"
				formControlName="motivoRevisione"
				[(ngModel)]="request.motivoRevisione"></div>
		</div>

		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>

		<div class="row">
			<div class="col-sm-3 col-xs-6">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm();">Reset</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p submitButton [labelButton]="'Salva'"></p>
			</div>
		</div>
	</form>
	</ng-template>
</div>